import React, { Component } from "react";
import InputRow from "./InputRow";
import Loading from "./Loading";
import PropTypes from "prop-types";
import { handleAlphabetCheck, arabicValue } from "../constants";
import InputRowArabic from "./InputRowArabic";
export default class PersonalInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fName: this.props.fName,
      mName: this.props.mName,
      lName: this.props.lName,
      dateOfBirth: "",
      gender: this.props.gender,
      countryData: [],
      selectedCountry: "",
      selectedNationality: "",
      error: "",
      errorBackend: "",
      loading: true,
      relationShipData: [],
      siblingFName: this.props.siblingFName || "",
      siblingMName: this.props.siblingMName || "",
      siblingLName: this.props.siblingLName || "",
      siblingTKHNumber: this.props.siblingTKHNumber || "",
      dobError: "",
    };
  }

  componentDidMount() {
    fetch(`${process.env.REACT_APP_API_URL}/api/PersonalInfo/GetLanguageLists`)
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          selectedCountry: this.props.countryOfBirth || "",
          selectedNationality: this.props.nationality || "",
        });
        if (this.props.arabicData.length) {
          this.setState({
            arabicText1:
              this.props.arabicData.length > 0
                ? this.props.arabicData[0].ColumnValue
                : "",
            arabicText2:
              this.props.arabicData.length > 1
                ? this.props.arabicData[1].ColumnValue
                : "",
            arabicText3:
              this.props.arabicData.length > 2
                ? this.props.arabicData[2].ColumnValue
                : "",
          });
        }
      })
      .then(() =>
        fetch(
          `${process.env.REACT_APP_API_URL}/api/parentinformation/getprefixes`
        )
      )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ prefixData: res, loading: false });
        if (res.length) {
          this.setState({ prefix: this.props.prefix || "" });
        }
        let dateOfBirth = "";
        if (this.props.dateOfBirth) {
          const date = new Date(this.props.dateOfBirth);
          let month = date.getMonth() + 1;
          let day = date.getDate();
          let year = date.getFullYear();
          if (month < 10) {
            month = "0" + month;
          }
          if (day < 10) {
            day = "0" + day;
          }
          if (year < 10) {
            year = "000" + year;
          } else if (year < 100) {
            year = "00" + year;
          } else if (year < 1000) {
            year = "0" + year;
          }
          dateOfBirth = year + "-" + month + "-" + day;
        }
        this.setState({ dateOfBirth: dateOfBirth });
      })
      .catch((err) => console.log(err));
  }

  render() {
    const validationError = this.props.error;
    const {
      loading,
      error,
      dobError,
      errorBackend,
      fName,
      mName,
      lName,
      dateOfBirth,
      selectedCountry,
      selectedNationality,
      gender,
      arabicText1,
      arabicText2,
      arabicText3,
      siblingFName,
      siblingMName,
      siblingLName,
      siblingTKHNumber,
    } = this.state;
    if (loading) {
      return <Loading />;
    }
    return (
      <div>
        <div>
          {error && <p style={{ color: "red" }}>{error}</p>}
          {errorBackend && <p>{errorBackend}</p>}
          <div>
            <p>
              Full name has to be entered & to be identical to formal documents
            </p>
          </div>
          <div>
            <InputRow
              rowName="First Name"
              name="text"
              required="*"
              errMsg={validationError.fName ? validationError.fName : ""}
              value={fName}
              hover="Insert your First Name as it appears in your Official Documents.  ادخل اسمك الأول كما يظهر فى مستنداتك الرسمية"
              onChange={(val) => {
                if (handleAlphabetCheck(val) === 1 || val === "") {
                  this.setState({ fName: val });
                  this.props.collectState("PI", {
                    fName: val,
                    mName: mName,
                    lName: lName,
                    dateOfBirth: dateOfBirth,
                    selectedCountry: selectedCountry,
                    selectedNationality: selectedNationality,
                    gender: gender,
                    arabicText1: arabicText1,
                    arabicText2: arabicText2,
                    arabicText3: arabicText3,
                    siblingFName: siblingFName,
                    siblingMName: siblingMName,
                    siblingLName: siblingLName,
                    siblingTKHNumber: siblingTKHNumber,
                  });
                } else {
                  alert("Enter letters only!");
                }
              }}
            />
            <InputRow
              rowName="Middle Name [s]"
              value={mName}
              name="text"
              required="*"
              errMsg={validationError.mName ? validationError.mName : ""}
              hover="Insert your Middle Name as it appears in your Official Documents. ادخل باقى الاسم كما يظهر فى مستنداتك الرسمية"
              onChange={(val) => {
                if (handleAlphabetCheck(val) === 1 || val === "") {
                  this.setState({ mName: val });
                  this.props.collectState("PI", {
                    fName: fName,
                    mName: val,
                    lName: lName,
                    dateOfBirth: dateOfBirth,
                    selectedCountry: selectedCountry,
                    selectedNationality: selectedNationality,
                    gender: gender,
                    arabicText1: arabicText1,
                    arabicText2: arabicText2,
                    arabicText3: arabicText3,
                    siblingFName: siblingFName,
                    siblingMName: siblingMName,
                    siblingLName: siblingLName,
                    siblingTKHNumber: siblingTKHNumber,
                  });
                } else {
                  alert("Enter letters only!");
                }
              }}
            />
            <InputRow
              rowName="Last Name"
              name="text"
              value={lName}
              required="*"
              errMsg={validationError.lName ? validationError.lName : ""}
              onChange={(val) => {
                if (handleAlphabetCheck(val) === 1 || val === "") {
                  this.setState({ lName: val });
                  this.props.collectState("PI", {
                    fName: fName,
                    mName: mName,
                    lName: val,
                    dateOfBirth: dateOfBirth,
                    selectedCountry: selectedCountry,
                    selectedNationality: selectedNationality,
                    gender: gender,
                    arabicText1: arabicText1,
                    arabicText2: arabicText2,
                    arabicText3: arabicText3,
                    siblingFName: siblingFName,
                    siblingMName: siblingMName,
                    siblingLName: siblingLName,
                    siblingTKHNumber: siblingTKHNumber,
                  });
                } else {
                  alert("Enter letters only!");
                }
              }}
            />
            <InputRow
              rowName="Gender"
              name="select"
              value={gender}
              data={[
                { Id: "Female", value: "Female" },
                { Id: "Male", value: "Male" },
              ]}
              required="*"
              errMsg={validationError.gender ? validationError.gender : ""}
              onChange={(val) => {
                this.setState({ gender: val });
                this.props.collectState("PI", {
                  fName: fName,
                  mName: mName,
                  lName: lName,
                  dateOfBirth: dateOfBirth,
                  selectedCountry: selectedCountry,
                  selectedNationality: selectedNationality,
                  gender: val,
                  arabicText1: arabicText1,
                  arabicText2: arabicText2,
                  arabicText3: arabicText3,
                  siblingFName: siblingFName,
                  siblingMName: siblingMName,
                  siblingLName: siblingLName,
                  siblingTKHNumber: siblingTKHNumber,
                });
              }}
            />

            <InputRow
              rowName="Date of Birth"
              name="date"
              value={dateOfBirth}
              required="*"
              errMsg={
                dobError ||
                (validationError.dateOfBirth ? validationError.dateOfBirth : "")
              }
              onChange={(val) => {
                this.setState({ error: "" });
                const dob = new Date(val);

                if (!isNaN(dob.getFullYear())) {
                  if (parseInt(dob.getFullYear()) <= 9999) {
                    const diffMs = Date.now() - dob.getTime();
                    const ageDt = new Date(diffMs);
                    const age = Math.abs(ageDt.getUTCFullYear() - 1970);
                    if (age < 15 || age > 80) {
                      this.setState({
                        dobError: "Age must be between 15 and 80 years",
                        dateOfBirth: "",
                      });
                    } else if (isNaN(dob.getFullYear())) {
                    } else {
                      this.setState({ dateOfBirth: val });
                      this.setState({ dobError: "" });
                      this.props.collectState("PI", {
                        fName: fName,
                        mName: mName,
                        lName: lName,
                        dateOfBirth: val,
                        selectedCountry: selectedCountry,
                        selectedNationality: selectedNationality,
                        gender: gender,
                        arabicText1: arabicText1,
                        arabicText2: arabicText2,
                        arabicText3: arabicText3,
                        siblingFName: siblingFName,
                        siblingMName: siblingMName,
                        siblingLName: siblingLName,
                        siblingTKHNumber: siblingTKHNumber,
                      });
                    }
                  }
                } else {
                  this.setState({ dateOfBirth: "" });
                  this.setState({ dobError: "" });
                  this.props.collectState("PI", {
                    fName: fName,
                    mName: mName,
                    lName: lName,
                    dateOfBirth: "",
                    selectedCountry: selectedCountry,
                    selectedNationality: selectedNationality,
                    gender: gender,
                    arabicText1: arabicText1,
                    arabicText2: arabicText2,
                    arabicText3: arabicText3,
                    siblingFName: siblingFName,
                    siblingMName: siblingMName,
                    siblingLName: siblingLName,
                    siblingTKHNumber: siblingTKHNumber,
                  });
                }
              }}
            />
            <InputRow
              rowName="Country of Birth"
              value={selectedCountry}
              name="select"
              data={this.props.countryData}
              onChange={(val) => {
                this.setState({ selectedCountry: val });
                this.props.collectState("PI", {
                  fName: fName,
                  mName: mName,
                  lName: lName,
                  dateOfBirth: dateOfBirth,
                  selectedCountry: val,
                  selectedNationality: selectedNationality,
                  gender: gender,
                  arabicText1: arabicText1,
                  arabicText2: arabicText2,
                  arabicText3: arabicText3,
                  siblingFName: siblingFName,
                  siblingMName: siblingMName,
                  siblingLName: siblingLName,
                  siblingTKHNumber: siblingTKHNumber,
                });
              }}
              required="*"
              errMsg={
                validationError.selectedCountry
                  ? validationError.selectedCountry
                  : ""
              }
            />

            <InputRow
              rowName="Nationality"
              value={selectedNationality}
              name="select"
              data={this.props.countryData}
              required="*"
              errMsg={
                validationError.selectedNationality
                  ? validationError.selectedNationality
                  : ""
              }
              onChange={(val) => {
                this.setState({ selectedNationality: val });
                this.props.collectState("PI", {
                  fName: fName,
                  mName: mName,
                  lName: lName,
                  dateOfBirth: dateOfBirth,
                  selectedCountry: selectedCountry,
                  selectedNationality: val,
                  gender: gender,
                  arabicText1: arabicText1,
                  arabicText2: arabicText2,
                  arabicText3: arabicText3,
                  siblingFName: siblingFName,
                  siblingMName: siblingMName,
                  siblingLName: siblingLName,
                  siblingTKHNumber: siblingTKHNumber,
                });
              }}
            />
          </div>

          <div>
            <div>
              <InputRowArabic
                name="text"
                value={arabicText1}
                rowName=" إسم الطالب"
                required={selectedNationality == 50 ? "*" : ""}
                errMsg={
                  validationError.arabicText1 ? validationError.arabicText1 : ""
                }
                //required = "*"
                dir="rtl"
                writingDirection="rtl"
                textAlign="rtl"
                secureTextEntry="false"
                placeholder={"عربي"}
                onChange={(val) => {
                  const text = arabicValue(val);
                  this.setState({ arabicText1: text });
                  this.props.collectState("PI", {
                    fName: fName,
                    mName: mName,
                    lName: lName,
                    dateOfBirth: dateOfBirth,
                    selectedCountry: selectedCountry,
                    selectedNationality: selectedNationality,
                    gender: gender,
                    arabicText1: text,
                    arabicText2: arabicText2,
                    arabicText3: arabicText3,
                    siblingFName: siblingFName,
                    siblingMName: siblingMName,
                    siblingLName: siblingLName,
                    siblingTKHNumber: siblingTKHNumber,
                  });
                }}
              />
              <InputRowArabic
                name="text"
                value={arabicText2}
                rowName="اسم الاب"
                //required = "*"
                required={selectedNationality == 50 ? "*" : ""}
                dir="rtl"
                writingDirection="rtl"
                textAlign="rtl"
                secureTextEntry="false"
                placeholder={"عربي"}
                errMsg={
                  validationError.arabicText2 ? validationError.arabicText2 : ""
                }
                onChange={(val) => {
                  const text = arabicValue(val);
                  this.setState({ arabicText2: text });
                  this.props.collectState("PI", {
                    fName: fName,
                    mName: mName,
                    lName: lName,
                    dateOfBirth: dateOfBirth,
                    selectedCountry: selectedCountry,
                    selectedNationality: selectedNationality,
                    gender: gender,
                    arabicText1: arabicText1,
                    arabicText2: text,
                    arabicText3: arabicText3,
                    siblingFName: siblingFName,
                    siblingMName: siblingMName,
                    siblingLName: siblingLName,
                    siblingTKHNumber: siblingTKHNumber,
                  });
                }}
              />
              <InputRowArabic
                name="text"
                value={arabicText3}
                rowName="اسم  العائلة"
                // required = "*"
                required={selectedNationality == 50 ? "*" : ""}
                dir="rtl"
                writingDirection="rtl"
                textAlign="rtl"
                secureTextEntry="false"
                placeholder={"عربي"}
                errMsg={
                  validationError.arabicText3 ? validationError.arabicText3 : ""
                }
                onChange={(val) => {
                  const text = arabicValue(val);
                  this.setState({ arabicText3: text });
                  this.props.collectState("PI", {
                    fName: fName,
                    mName: mName,
                    lName: lName,
                    dateOfBirth: dateOfBirth,
                    selectedCountry: selectedCountry,
                    selectedNationality: selectedNationality,
                    gender: gender,
                    arabicText1: arabicText1,
                    arabicText2: arabicText2,
                    arabicText3: text,
                    siblingFName: siblingFName,
                    siblingMName: siblingMName,
                    siblingLName: siblingLName,
                    siblingTKHNumber: siblingTKHNumber,
                  });
                }}
              />
              <br />
            </div>
          </div>

          <button
            className="save"
            onClick={() => {
              this.props.onSave();
            }}
          >
            Next
          </button>
        </div>
      </div>
    );
  }
}

PersonalInformation.propTypes = {
  fName: PropTypes.string.isRequired,
  lName: PropTypes.string.isRequired,
  mName: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  countryData: PropTypes.array.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  gender: PropTypes.string,
  countryOfBirth: PropTypes.number,
  nationality: PropTypes.number,
  pLanguage: PropTypes.number,
  sLanguage: PropTypes.number,
  arabicData: PropTypes.array,
  dateOfBirth: PropTypes.string,
  error: PropTypes.object,
  collectState: PropTypes.func,
  siblingFName: PropTypes.string,
  siblingMName: PropTypes.string,
  siblingLName: PropTypes.string,
  siblingTKHNumber: PropTypes.string,
};
